// form-error-mappings.ts

export const FORM_ERROR_MAPPINGS: Record<string, string> = {
    'survey_element_unique_name_per_survey': 'An element with this name already exists in this survey. Please use a unique name.',
    'survey_element_name_js_valid': 'The name contains invalid characters. Must start with a letter or underscore (_). Use only letters, numbers, and underscores.',
    // Add more common database constraints here as you encounter them
    'violates foreign key constraint': 'This item cannot be deleted because it is being used elsewhere.',
    'violates not-null constraint': 'A required field is missing data.',
};